"use client";

import { Icon } from "@pamperedchef/design-system";
import * as styles from "./ProductTagList.module.scss";

export interface ProductTagListItem {
	label: string;
	icon?: string;
}

export interface ProductTagListProps {
	/**
	 * Guarantee, care and dietary tags. Callers select which tags qualify and
	 * resolve each icon; this composite stays presentational.
	 */
	items: ProductTagListItem[];
	/** Names the row for assistive tech; defaults to the product-facts wording. */
	ariaLabel?: string;
	className?: string;
}

export function ProductTagList({
	items,
	ariaLabel = "Product details",
	className
}: ProductTagListProps) {
	if (!items.length) return null;

	return (
		<ul
			className={[styles["product-tag-list"], className ?? ""]
				.filter(Boolean)
				.join(" ")}
			aria-label={ariaLabel}
			data-component="ProductTagList"
		>
			{items.map((item, idx) => (
				<li
					key={`${item.label}-${idx}`}
					className={styles["product-tag-list__item"]}
				>
					{item.icon ? (
						<span className={styles["product-tag-list__icon"]}>
							<Icon name={item.icon} width={22} height={22} />
						</span>
					) : null}
					<span>{item.label}</span>
				</li>
			))}
		</ul>
	);
}
